import { createContext } from 'react';

const ResultsContext = createContext({
  folderId: null,
  setFolderId: () => {},
});

export default ResultsContext;
